//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  components: {},
  props: [],
  data() {
    return {
      // 弹窗状态

      dialogVisible_add: false,
      dialogVisible_add_son: false,
      dialogVisible_amend: false,
      dialogVisible_remove: false,
      dialogVisible_removeTitle: false,
      dialogVisible_xiugai_son: false,

      // 表单数据

      numberValidateForm: {
        typeName: "", //分类名称
        topClass: "",
        slot: "",
        isShow: "10",
      },
      numberValidateForm2: {
        typeName: "", //分类名称
        topClass: "",
        slot: "",
        isShow: "10",
      },
      itemSon: [],
      sonName: "",
      amendDetail: {
        sort: "",
        name: "",
        id: "",
        level: "",
        status: 10,
      },
      //获取列表id

      getKey(val) {
        return val.id.toString();
      },
      remId: "",
      tableData: [],
      titleAmend: '',
      tableData1: [
        {
          id: 1,
          date: "2016-05-02",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
        },
        {
          id: 2,
          date: "2016-05-04",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1517 弄",
        },
        {
          id: 3,
          date: "2016-05-01",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1519 弄",
          hasChildren: true,
        },
        {
          id: 4,
          date: "2016-05-03",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1516 弄",
        },
      ],
    };
  },
  mounted() { },
  created() {
    this.fn();
  },
  methods: {
    //获取分类列表

    fn() {
      try {
        this.$http.orders.ordersList().then((res) => {
          console.log(res);
          this.tableData = res.data;
          // this.classFather = res.data
        });
      } catch (error) { }
    },

    // 添加分类

    addClass() {
      this.dialogVisible_add = true;
    },

    addList() {
      let obj = {
        name: this.numberValidateForm.typeName,
        sort: this.numberValidateForm.slot,
        pid: this.numberValidateForm.topClass.toString(),
        status: this.numberValidateForm.isShow,
        level: 2,
      };
      if (obj.pid == "") {
        console.log(obj);
        obj.pid = 0;
        obj.level = 1;
      }
      console.log(obj);
      this.$http.orders.addFenlei(obj).then((res) => {
        console.log(res);
        this.$message({
          message: res.message,
          type: "success",
        });
      });
      this.dialogVisible_add = false;
      this.fn();
    },

    // 添加子分类

    addSon(val) {
      this.dialogVisible_add_son = true;
      this.itemSon = val;
      this.sonName = val.name;
      console.log(val);
    },

    sontrue() {
      let levels = this.itemSon.level + 1;
      let obj = {
        name: this.numberValidateForm2.typeName,
        sort: this.numberValidateForm2.slot,
        pid: this.numberValidateForm2.topClass.toString() || this.itemSon.id,
        status: this.numberValidateForm2.isShow,
        level: levels,
      };
      if (obj.pid == "") {
        console.log(obj);
        obj.pid = 0;
      }
      console.log(obj);
      this.$http.orders.addFenlei(obj).then((res) => {
        console.log(res);
        this.$message({
          message: res.message,
          type: "success",
        });
      });
      this.dialogVisible_add_son = false;
      this.fn();
      // (this.$refs.table as any).toggleRowExpansion(parentldArr, true)
    },

    //编辑

    amend(val) {
      console.log(val)
      this.dialogVisible_amend = true;
      this.amendDetail = {
        sort: val.sort,
        name: val.name,
        id: val.id,
        level: val.level,
        status: val.status,
        pid: val.pid
      };
      this.titleAmend = val.name
      this.itemSon = val;
      // console.log(typeof (this.amendDetail.sort));
      // console.log(typeof (this.amendDetail.name));
      // typeof(amendDetail.sort)
    },

    amendAway() {
      this.dialogVisible_amend = false;
      this.dialogVisible_xiugai_son = true;
    },

    xiugaitrue() {
      console.log(this.amendDetail);
      let obj = this.amendDetail;
      this.$http.orders.editList(obj).then((res) => {
        console.log(res);
        this.$message({
          message: res.message,
          type: "success",
        });
      });
      this.dialogVisible_xiugai_son = false;

      this.fn();
    },

    //删除

    removeList(val) {
      this.remId = val.id;
      console.log(val)
      this.$http.brandApi
        .getRemTitle({
          brandId: "",
          oneClassId: val.id,
          supplierId: "",
          threeClassId: "",
          twoClassId: "",
        })
        .then((res) => {
          console.log(res.data);
          if (res.data == 0) {
            this.dialogVisible_remove = true;

          } else {
            this.dialogVisible_removeTitle = true;
          }
          // this.dialogVisible_remove = false
          // this.$message({
          //     message: res.message,
          //     type: 'success'
          // });
        });

      // console.log(val.id)
      // this.remId = val.id
      // this.dialogVisible_remove = true
      // this.dialogVisible_removeTitle = true
    },

    removeData() {
      let obj = {
        id: this.remId,
      };
      this.$http.orders.remFenlei(obj).then((res) => {
        console.log(res);
        this.dialogVisible_remove = false;
        this.$message({
          message: res.message,
          type: "success",
        });
      });
      this.fn();
    },

    //滑块是否展示

    stsShow(val) {
      try {
        console.log(val);
        let blen = "";
        if (val.status == 10) {
          blen = 20;
        } else {
          blen = 10;
        }
        let obj = {
          id: val.id.toString(),
          status: blen,
        };
        this.$http.orders.ordersShow(obj).then((res) => {
          console.log(res);
        });
        this.fn();
      } catch (error) {
        console.log(error);
      }
    },
  },
};
